module.exports = __webpack_public_path__ + "media/images/consulting-94ef039ee1d6679f317cc424cce5bd0e.png";